import React, { useState } from 'react';
import DataService from '../../services/data.service';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    user_id:DataService.getUserDetails().id
  });
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    const { currentPassword, newPassword, confirmPassword } = formData;

    if (!currentPassword) newErrors.currentPassword = 'Current password is required.';
    if (!newPassword || newPassword.length < 6)
      newErrors.newPassword = 'New password must be at least 6 characters.';
    if (newPassword !== confirmPassword)
      newErrors.confirmPassword = 'Passwords do not match.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading(true);
      // Replace with your API call
      await DataService.changePassword(formData);
      toast.success('Password changed successfully, Please login again.');
      setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      DataService.deleteAccessToken();
        navigate('/login');

    } catch (error) {
        console.log(error)
      toast.error(error.response.data.error);
    } finally {
      setLoading(false);
    }
  };

  return (
  <>
      <h4>Change Password</h4>
      <form onSubmit={handleSubmit} className="mt-3">
        <div className="mb-3">
          <label className="form-label">Current Password</label>
          <input
            type="password"
            name="currentPassword"
            className={`form-control px-3 ${errors.currentPassword ? 'is-invalid' : ''}`}
            value={formData.currentPassword}
            onChange={handleChange}
          />
          {errors.currentPassword && <div className="invalid-feedback">{errors.currentPassword}</div>}
        </div>

        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            type="password"
            name="newPassword"
            className={`form-control px-3 ${errors.newPassword ? 'is-invalid' : ''}`}
            value={formData.newPassword}
            onChange={handleChange}
          />
          {errors.newPassword && <div className="invalid-feedback">{errors.newPassword}</div>}
        </div>

        <div className="mb-3">
          <label className="form-label">Confirm New Password</label>
          <input
            type="password"
            name="confirmPassword"
            className={`form-control px-3 ${errors.confirmPassword ? 'is-invalid' : ''}`}
            value={formData.confirmPassword}
            onChange={handleChange}
          />
          {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
      </form>
</>
  );
};

export default ChangePassword;
